import { Dialog } from '@cimplico/components';

type EditEntityConfirmProps = {
    onClose: () => void;
    onEdit: () => void;
};

function EditEntityConfirm({ onClose, onEdit }: EditEntityConfirmProps): JSX.Element {
    return (
        <Dialog
            type="info"
            title="Edit Entity"
            description="Editing the entity type may affect the procedure list and certification status of open workpapers."
            primaryAction="Confirm"
            secondaryAction="Cancel"
            isOpen
            onClose={onClose}
            onPrimaryActionClick={onEdit}
            onSecondaryActionClick={onClose}
        />
    );
}
export default EditEntityConfirm;
